import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import QualityRequirementsComponent from './QualityRequirementsComponent';

class QualityRequirementsContainer extends PureComponent {
  render = () => {
    const {
      inviteeQreqText,
      inviterQreqText,
    } = this.props;

    return (
      <QualityRequirementsComponent
        inviteeQreqText={inviteeQreqText}
        inviterQreqText={inviterQreqText}
      />
    );
  }
}

QualityRequirementsContainer.propTypes = {
  inviteeQreqText: PropTypes.string.isRequired,
  inviterQreqText: PropTypes.string.isRequired,
};

const mapStateToProps = ({
  socialAct: {
    inviteeData: {
      actInviterQReqText: inviterQreqText,
      actQReqText: inviteeQreqText,
    },
  },
}) => ({
  inviteeQreqText,
  inviterQreqText,
});

export default connect(mapStateToProps)(QualityRequirementsContainer);